const exportedObject = {
  obtenerEspecialidadesMedicasData: {},
  obtenerEspecialidadesMedicasLoading: false,
  obtenerEspecialidadesMedicasError: null,
};

export default exportedObject;

